export enum DerbysoftSupplier {
  VERTICAL_BOOKING = 'VERTICAL_BOOKING',
  CLOUDBEDS = 'CLOUDBEDS',
}

export type DerbysoftSupplierConfig = {
  name: string;
  iconPath: string;
  classPrefix: string;
};

export const DERBYSOFT_SUPPLIER_CONFIG: Record<
  DerbysoftSupplier,
  DerbysoftSupplierConfig
> = {
  [DerbysoftSupplier.VERTICAL_BOOKING]: {
    name: 'Vertical Booking',
    iconPath: 'static/icons/vertical_booking_inventory.png',
    classPrefix: 'vertical-booking',
  },
  [DerbysoftSupplier.CLOUDBEDS]: {
    name: 'Cloudbeds',
    iconPath: 'static/icons/cloudbeds_inventory.png',
    classPrefix: 'cloudbeds',
  },
};

export const getDerbysoftSupplierConfig = (
  supplierId?: string
): DerbysoftSupplierConfig | undefined => {
  if (!supplierId) {
    return undefined;
  }

  return DERBYSOFT_SUPPLIER_CONFIG[supplierId as DerbysoftSupplier];
};

export const getDerbysoftSuppliersDataSource = () =>
  Object.entries(DERBYSOFT_SUPPLIER_CONFIG).map(([id, config]) => ({
    id,
    name: config.name,
  }));
